export default __webpack_public_path__ + "static/media/deliveries_4.96f23352.png";